"use client"
import Script from "next/script";

declare var window: {
  adobeDataLayer: {
    push: (data: any) => void;
  };
};

export default function ScriptWA() {
  return (
    <>
      <Script
        src={process.env.NEXT_PUBLIC_WEB_ADOBE_LAUNCH}
        type="text/javascript"
      />
    </>
  );
}